import type { AddressType } from '~~/types/AddressType';

export const POSTAL_CODE_FIELD = 'postalCode' as const;

export interface PostalCodeCartError {
  field: typeof POSTAL_CODE_FIELD;
  addressType: AddressType;
}

export const isPostalCodeCartError = (value: unknown): value is PostalCodeCartError => {

  if (!value || typeof value !== 'object') {

    return false;

  }

  const candidate = value as Record<string, unknown>;

  return candidate.field === POSTAL_CODE_FIELD &&
    (candidate.addressType === 'Shipping' || candidate.addressType === 'Billing');

};
